import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AuthModule } from '~/auth/auth.module';
import { ComponentModule } from '~/component/component.module';
import { CoreModule } from '~/core/core.module';
import { OrganizerSharedModule } from '~/organizer/shared/shared.module';
import { ParamethorModule } from '~/paramethor/paramethor.module';

import { OrganizerActivityRoutingModule } from './activity-routing.module';
import { OrganizerActivitiesComponent } from './components/pages/activities.component';
import { OrganizerActivityDatesPageComponent } from './components/pages/dates/dates.component';
import { OrganizerActivityPageManageComponent } from './components/pages/manage/manage.component';

/**
 * Organizer Activity management
 */
@NgModule({
  declarations: [
    OrganizerActivityPageManageComponent,
    OrganizerActivitiesComponent,
    OrganizerActivityDatesPageComponent,
  ],
  imports: [
    ReactiveFormsModule,
    FormsModule,
    AuthModule,
    CommonModule,
    CoreModule,
    OrganizerActivityRoutingModule,
    ComponentModule,
    ParamethorModule,
    OrganizerSharedModule,
  ],
})
export class OrganizerActivityModule {}
